import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { VERSION_FULL } from '../../lib/version';

export function AppFooter() {
    const { t } = useTranslation();
    const year = new Date().getFullYear();

    return (
        <footer className="app-footer app-shell__footer py-3">
            <Container className="d-flex flex-wrap justify-content-between align-items-center gap-2">
                <span>
                    © {year} {t('footer.tagline')}
                </span>
                <span className="app-footer__version" title={`${t('footer.version')} ${VERSION_FULL}`}>
                    {VERSION_FULL}
                </span>
            </Container>
        </footer>
    );
}
